module.exports = __webpack_public_path__ + "img/303-loop2.7eeab87d.svg";